import {connect} from "react-redux";
import React, {useEffect, useState} from "react";
import "pages/Styles/UIKit_v2.sass";
import "pages/Styles/ProfileV2.sass";
import {httpClient, preparePhoneNumber} from "../../funcs";
import {notifyAboutError, notifyUser} from "../../methods/notifyUser";
import {userFullname} from "../../methods/utils";
import {finishAuth} from "../../methods/finishAuth";
import {useRoute} from "react-router5";
import _ from "lodash";
import {checkPermission, UserPermission} from "../../methods/permissionByRole";
import InviteEmployeePopup from "./InviteEmployeePopup";
import AccessProfilePopup from "./AccessProfilePopup";
import EmployeeTemplatesAccessPopup from "./EmployeeTemplatesAccessPopup";
import {CopyToClipboard} from "react-copy-to-clipboard";
import DeleteAccountPopup from "./DeleteAccountPopup";
import {PageLoader} from "../Contracts/ContractList/PageLoader";
import { loadRoles } from "../../utils/workWithRoles";
import { prepareTokenData } from "../../utils/tokenUtils";
import Popup from "../../components/Popup";
import SelectOptionsView from "../Contracts/SelectOptionsView";
import {
    AccessProfile,
    accessChoiceOptions,
    isBuiltinAccessLevel,
    roleAccessChoiceId,
} from "../../methods/templatePermissions";

// Enum для статусов приглашений
enum InvitationStatus {
    INVITED = 'INVITED',
    CONFIRMED = 'CONFIRMED',
    REVOKED = 'REVOKED'
}

// Функция для форматирования даты без лишних нулей
function formatDate(dateString: string) {
    if (!dateString) return '';
    
    try {
        // Парсим дату как UTC и конвертируем в локальное время
        const date = new Date(dateString + 'Z'); // Добавляем 'Z' для указания UTC
        if (isNaN(date.getTime())) return '';
        
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        
        return `${day}.${month}.${year}, ${hours}:${minutes}`;
    } catch (error) {
        return '';
    }
}



let TeamView: any = function TeamView(props: any) {
    const $router = useRoute()

    const [showInvite, setShowInvite] = useState(false)
    const [showDeleteAccount, setShowDeleteAccount] = useState(false)
    const [accountToDelete, setAccountToDelete] = useState<any>(null)

    const [rolesLoaded, setRolesLoaded] = useState(false)
    const [currentUserId, setCurrentUserId] = useState(props.$store.userSession?._id)
    const [users, setUsers] = useState<any[]>([])
    const [grantedToYouRoles, setGrantedToYouRoles] = useState<any[]>([])
    const [grantedByYouRoles, setGrantedByYouRoles] = useState<any[]>([])

    const [editRolePopupOpen, setEditRolePopupOpen] = useState(false)
    const [roleToEdit, setRoleToEdit] = useState<any>(null)
    const [roleRepresentativeBasis, setRoleRepresentativeBasis] = useState<string>("")
    const [accessProfiles, setAccessProfiles] = useState<AccessProfile[]>([])
    const [profileEditor, setProfileEditor] = useState<AccessProfile | "new" | null>(null)
    const [templatesAccessRole, setTemplatesAccessRole] = useState<any>(null)

    useEffect(() => {
        getUserList()
        if (!props.$store.userSession?.role_id) {
            loadAccessProfiles()
        }
    }, [])

    useEffect(() => {
        let inviteRoleId = props.$store.inviteRoleId
        if (inviteRoleId && rolesLoaded) {
            let role = grantedToYouRoles.filter((role: any) => role._id == inviteRoleId)[0]
            if (role) {
                notifyUser(props, `Вас пригласил ${userFullname(role.granted_by)}`, 'Примите его приглашение чтобы начать работать')
            } else {
                notifyUser(props, 'Приглашение не найдено', 'Убедитесь, что приглашение выдано на ваш номер телефона, или обратитесь в тех поддержку')
            }
            props.$commitToStore({
                inviteRoleId: null
            })
        }
    }, [grantedToYouRoles, rolesLoaded])

    async function getUserList() {
        props.$commitToStore({
            loading: true
        })

        try {
            const { users, grantedToYouRoles, grantedByYouRoles, currentUserId, myUserId } = await loadRoles(props.$store.userSession?._id, props);

            setCurrentUserId(currentUserId)
            setUsers(users)
            setGrantedToYouRoles(grantedToYouRoles)
            setGrantedByYouRoles(grantedByYouRoles)
            setRolesLoaded(true)
        } catch (error) {
            notifyAboutError(props, error)
        } finally {
            props.$commitToStore({
                loading: false
            })
        }
    }

    async function loadAccessProfiles() {
        try {
            const {data} = await httpClient.get('/access-profiles')
            setAccessProfiles(data.profiles || [])
        } catch (error) {
            notifyAboutError(props, error)
        }
    }

    function invitePayload(accessChoice: string) {
        if (isBuiltinAccessLevel(accessChoice)) {
            // Новый сотрудник: ничего не видно, пока не выдадут шаблоны.
            return {access_level: accessChoice, template_scope: 'selected', allowed_templates: {}}
        }
        return {access_profile_id: accessChoice}
    }

    function accessChoiceUpdatePayload(accessChoice: string) {
        if (isBuiltinAccessLevel(accessChoice)) {
            // Не трогаем allowlist — только уровень и сброс профиля.
            return {access_level: accessChoice}
        }
        return {access_profile_id: accessChoice}
    }

    async function invite(phoneNumber: string, accessChoice: string) {
        props.$commitToStore({
            loading: true
        })

        try {
            let { data } = await httpClient.post(
                `/create-role`,
                {
                    'phone_number': preparePhoneNumber(phoneNumber),
                    ...invitePayload(accessChoice),
                }
            )

            notifyUser(props, data.text)
        } catch (error) {
            notifyAboutError(props, error)
        } finally {
            props.$commitToStore({
                loading: false
            })
        }
    }

    async function revoke(role: any) {
        props.$commitToStore({
            loading: true
        })

        try {
            let { data } = await httpClient.put(
                `/revoke-role`,
                {'_id': role._id}
            )

            notifyUser(props, data.text)
        } catch (error) {
            notifyAboutError(props, error)
        } finally {
            props.$commitToStore({
                loading: false
            })
        }
    }

    async function updateRoleAccessChoice(role: any, accessChoice: string) {
        props.$commitToStore({
            loading: true
        })

        try {
            await httpClient.patch(
                `/update-role`,
                {
                    '_id': role._id,
                    ...accessChoiceUpdatePayload(accessChoice),
                }
            )
            notifyUser(props, "Уровень доступа обновлён")
        } catch (error) {
            notifyAboutError(props, error)
        } finally {
            props.$commitToStore({
                loading: false
            })
        }
    }

    function accessChoiceOption(role: any) {
        const choiceId = roleAccessChoiceId(role)
        return accessChoiceOptions(accessProfiles).find((option) => option.id === choiceId)
            || accessChoiceOptions()[0]
    }

    async function updateRoleRepresentativeBasis(role: any, value: string) {
        props.$commitToStore({
            loading: true
        })

        try {
            await httpClient.patch(
                `/update-role`,
                {
                    '_id': role._id,
                    'first_signer_representative_basis_override': value
                }
            )
            notifyUser(props, "Данные сотрудника обновлены")
        } catch (error) {
            notifyAboutError(props, error)
        } finally {
            props.$commitToStore({
                loading: false
            })
        }
    }

    async function accept(role: any) {
        props.$commitToStore({
            loading: true
        })

        try {
            let { data } = await httpClient.put(
                `/accept-role`,
                {'_id': role._id}
            )

            notifyUser(props, data.text)
        } catch (error) {
            notifyAboutError(props, error)
        } finally {
            props.$commitToStore({
                loading: false
            })
        }
    }

    function userView(user: any) {
        if (user) {
            return <div>
                <div className="Subheader_18">
                    {
                        userFullname(user)
                    }
                </div>
                <div className="Body_16_v2_secondary">
                    {user.phone_number}, {user.email}
                </div>
            </div>
        }
    }

    function makeUsersView() {
        // Проверяем, вошел ли пользователь через роль сотрудника
        // Если есть role_id в userSession, значит пользователь вошел через роль сотрудника
        const isEmployeeRole = props.$store.userSession?.role_id;
        
        return <div className="team-view-sections ui-kit-v2">
            {
                // Если пользователь вошел через роль сотрудника, показываем текущий бизнес аккаунт
                isEmployeeRole &&
                makeCurrentBusinessAccountView()
            }

            {
                users.length > 0 &&
                makeMyUsersView()
            }

            {
                !isEmployeeRole &&
                makeAccessProfilesView()
            }

            {
                // Показываем "Сотрудники, подключенные к вашему аккаунту" только если пользователь НЕ вошел через роль сотрудника
                !isEmployeeRole && grantedByYouRoles.length > 0 &&
                makeGrantedByYouView()
            }

            {
                grantedToYouRoles.length > 0 &&
                makeGrantedToYouView()
            }
        </div>
    }

    function makeCurrentBusinessAccountView() {
        // Если пользователь вошел через роль сотрудника, показываем его текущий аккаунт
        // В grantedToYouRoles лежит сам пользователь с role_id
        const currentBusinessAccount = props.$store.userSession;

        
        if (!currentBusinessAccount || !currentBusinessAccount.role_id) return null;
        
        return <div className="profile-section-card profile-section-card--no-border ui-kit-v2" style={{marginBottom: "20px"}}>
            <div className="profile-section-title">
                Текущий бизнес аккаунт
            </div>
            <div className="profile-section-subtitle">
                Вы работаете в этом аккаунте как сотрудник
            </div>
            <div style={{marginTop: "10px"}}>
                <div
                    className="profile-section-card ui-kit-v2 disabledHover"
                >
                    {
                        userView(currentBusinessAccount)
                    }
                    <div style={{marginTop: "15px"}}>
                        <div className="Body_16_v2_secondary Subheader_14" style={{
                            color: '#2E7D32'
                        }}>
                            Активен (роль сотрудника)
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }

    function makeMyUsersView() {
        return <div className="profile-section-card profile-section-card--no-border ui-kit-v2" style={{marginBottom: "20px"}}>
            <div className="profile-section-title">
                Ваши аккаунты
            </div>
            <div className="profile-section-subtitle">
                На один номер можно максимум завести 2 аккаунта - один как физ. лицо и один как юр. лицо. Чтобы завести новый аккаунт - выйдите из текущего и перейдите в регистрацию нового аккаунта
            </div>
            <div className="cells-list" style={{marginTop: "10px"}}>
                {
                    users.map((user: any) => {
                        return <div
                            key={user._id}
                            className="profile-section-card ui-kit-v2 disabledHover"
                        >
                            {
                                userView(user)
                            }
                            {
                                makeMyUsersButtons(user)
                            }
                        </div>
                    })
                }
            </div>
        </div>
    }

    function makeMyUsersButtons(user: any) {
        return <div className="buttonsContainer" style={{marginTop: "15px", display: "flex", gap: "10px", flexWrap: "wrap"}}>
            <button
                className="new action-button primary"
                disabled={currentUserId == user._id}
                onClick={async () => {
                    const tokenData = prepareTokenData(user);
                    await finishAuth(props, $router, tokenData, 'profile')
                    props.$commitToStore({
                        role: null
                    })
                    await getUserList()
                    location.reload()
                }}
            >
                <span className="button-text">{currentUserId == user._id ? "Текущий" : "Войти"}</span>
            </button>
            {
                user.role === 'customer' && 
                <button
                    className="new action-button secondary"
                    style={{color: "#D32F2F"}}
                    onClick={() => {
                        setAccountToDelete(user)
                        setShowDeleteAccount(true)
                    }}
                >
                    <span className="button-text">Удалить аккаунт</span>
                </button>
            }
        </div>
    }

    function makeAccessProfilesView() {
        return <div className="profile-section-card profile-section-card--no-border ui-kit-v2" style={{marginBottom: "20px"}}>
            <div className="profile-section-title">
                Роли доступа
            </div>
            <div className="profile-section-subtitle">
                Своя роль: либо права на все шаблоны с исключениями, либо только выбранные (как у сотрудника).
            </div>
            <div className="cells-list" style={{marginTop: "10px"}}>
                {
                    accessProfiles.map((profile) => {
                        return <div
                            key={profile._id}
                            className="profile-section-card ui-kit-v2 disabledHover"
                        >
                            <div className="Subheader_18">{profile.name}</div>
                            <div className="Body_16_v2_secondary" style={{marginTop: "4px"}}>
                                {profile.scope === 'selected'
                                    ? 'Только выбранные шаблоны'
                                    : ((profile.default_permissions || []).length
                                        ? `По умолчанию: ${(profile.default_permissions || []).join(', ')}`
                                        : 'По умолчанию: шаблоны скрыты')}
                            </div>
                            <div style={{marginTop: "12px"}}>
                                <button
                                    className="new action-button secondary"
                                    onClick={() => setProfileEditor(profile)}
                                >
                                    <span className="button-text">Изменить</span>
                                </button>
                            </div>
                        </div>
                    })
                }
            </div>
            <div className="profile-section-row" style={{marginTop: "12px"}}>
                <button
                    className="new action-button secondary"
                    onClick={() => setProfileEditor("new")}
                >
                    <span className="button-text">Создать роль</span>
                </button>
            </div>
        </div>
    }

    function makeGrantedByYouView() {
        return <div className="profile-section-card profile-section-card--no-border ui-kit-v2" style={{marginBottom: "20px"}}>
            <div className="profile-section-title">
                Сотрудники, подключенные к вашему аккаунту
            </div>
            <div className="profile-section-subtitle">
                Новый сотрудник по умолчанию не видит шаблоны и договоры. Выдайте нужные в «Доступ к шаблонам».
            </div>
            <div className="cells-list" style={{marginTop: "10px"}}>
                {
                    grantedByYouRoles.map((user: any) => {
                        return <div
                            key={user._id}
                            className="profile-section-card ui-kit-v2 disabledHover"
                        >
                            <div>
                                {
                                    userView(user.granted_to)
                                }

                                {
                                    user.granted_to_phone_number &&
                                    <div className="Subheader_18">
                                        { user.granted_to_phone_number }
                                    </div>
                                }
                                
                                {/* Статус приглашения */}
                                {user.status === InvitationStatus.CONFIRMED && (() => {
                                    // Если есть дата принятия, используем её для расчета
                                    if (user.accepted_at) {
                                        const acceptedDate = new Date(user.accepted_at + 'Z');
                                        if (!isNaN(acceptedDate.getTime())) {
                                            const now = new Date();
                                            const diffDays = Math.floor((now.getTime() - acceptedDate.getTime()) / (1000 * 60 * 60 * 24));
                                            
                                            return (
                                                <div className="Body_16_v2_secondary Subheader_14" style={{
                                                    marginTop: "5px",
                                                    color: '#2E7D32'
                                                }}>
                                                    {diffDays > 3 ? 'Активен' : `Приглашение принято ${formatDate(user.accepted_at)}`}
                                                </div>
                                            );
                                        }
                                    }
                                    
                                    // Если нет даты принятия или она невалидна, показываем "Активен"
                                    return (
                                        <div className="Body_16_v2_secondary Subheader_14" style={{
                                            marginTop: "5px",
                                            color: '#2E7D32'
                                        }}>
                                            Активен
                                        </div>
                                    );
                                })()}
                                
                                {user.status === InvitationStatus.INVITED && (
                                    <div className="Body_16_v2_secondary Subheader_14" style={{
                                        marginTop: "5px",
                                        color: '#E65100'
                                    }}>
                                        Ожидает подтверждения
                                    </div>
                                )}
                                

                                

                                

                                
                                {
                                    makeGrantedByYouButtons(user)
                                }
                                <div style={{marginTop: "12px"}}>
                                    <div className="Body_16_v2_secondary Subheader_14" style={{marginBottom: "6px"}}>
                                        Уровень доступа
                                    </div>
                                    <SelectOptionsView
                                        selectedOption={accessChoiceOption(user)}
                                        onSelectOption={async (option: any) => {
                                            if (!option?.id || option.id === roleAccessChoiceId(user)) {
                                                return
                                            }
                                            await updateRoleAccessChoice(user, option.id)
                                            await getUserList()
                                        }}
                                        options={accessChoiceOptions(accessProfiles)}
                                        placeholder="Уровень доступа"
                                        freeSolo={false}
                                        width="full"
                                        popperZIndex={2000}
                                    />
                                </div>
                                <div style={{marginTop: "12px"}}>
                                    <button
                                        className="new action-button secondary"
                                        onClick={() => setTemplatesAccessRole(user)}
                                    >
                                        <span className="button-text">Доступ к шаблонам</span>
                                    </button>
                                    <div className="Body_16_v2_secondary Subheader_14" style={{marginTop: "6px"}}>
                                        {user.access_profile_id
                                            ? 'Управляется ролью доступа'
                                            : (user.template_scope === 'all'
                                                ? 'Все шаблоны аккаунта'
                                                : `Выдано шаблонов: ${Object.keys(user.allowed_templates || {}).length}`)}
                                    </div>
                                </div>
                            </div>
                        </div>
                    })
                }
            </div>
        </div>
    }

    function makeGrantedByYouButtons(user: any) {
        return <div style={{marginTop: "15px", display: "flex", gap: "10px", flexWrap: "wrap"}}>
            {
                user.status == InvitationStatus.INVITED &&
                <CopyToClipboard
                    text={`Вас пригласили присоединиться к аккаунту ${userFullname(props.$store.userSession)} в ОкиДоки. Пройдите про ссылке и зарегистрируйтесь (если у вас нет аккаунта). Затем, подтвердите приглашение. \n\n ${user.invite_link}`}
                >
                    <button
                        className="new action-button secondary"
                        onClick={() => {
                            notifyUser(props, "Отправьте скопированную ссылку вашему сотруднику")
                        }}
                    >
                        <span className="button-text">Скопировать приглашение</span>
                    </button>
                </CopyToClipboard>
            }
            {
                user.status === InvitationStatus.CONFIRMED &&
                <button
                    className="new action-button secondary"
                    onClick={() => {
                        setRoleToEdit(user)
                        setRoleRepresentativeBasis((user.first_signer_representative_basis_override ?? '').toString())
                        setEditRolePopupOpen(true)
                    }}
                >
                    <span className="button-text">Основание полномочий (в лице…)</span>
                </button>
            }
            <button
                className="new action-button secondary"
                onClick={async () => {
                    await revoke(user)
                    await getUserList()
                }}
            >
                <span className="button-text">{user.status === InvitationStatus.CONFIRMED ? 'Отключить сотрудника' : 'Отозвать приглашение'}</span>
            </button>
        </div>
    }

    function makeGrantedToYouView() {
        return <div className="profile-section-card profile-section-card--no-border ui-kit-v2" style={{marginBottom: "20px"}}>
            <div className="profile-section-title">
                Аккаунты, к которым вам выдали доступ как сотруднику
            </div>
            <div className="cells-list" style={{marginTop: "10px"}}>
                {
                    grantedToYouRoles
                        .filter((user: any) => user.granted_by) // Фильтруем записи без granted_by
                        .map((user: any) => {
                        return <div
                            key={user._id}
                            className="profile-section-card ui-kit-v2 disabledHover"
                        >
                            {
                                userView(user.granted_by)
                            }
                            {
                                makeGrantedToYouButtons(user)
                            }
                        </div>
                    })
                }
            </div>
        </div>
    }

    function makeGrantedToYouButtons(user: any) {
        // Если нет granted_by, не показываем кнопки
        if (!user.granted_by) {
            return null;
        }

        return <div style={{marginTop: "15px"}}>
            {
                user.status == InvitationStatus.CONFIRMED &&
                <button
                    className="new action-button primary"
                    disabled={currentUserId == user.granted_by._id}
                    onClick={async () => {
                        const tokenData = prepareTokenData(user);
                        await finishAuth(props, $router, tokenData, 'profile')
                        props.$commitToStore({
                            role: user
                        })
                        await getUserList()
                        location.reload()
                    }}
                >
                    <span className="button-text">{currentUserId == user.granted_by._id ? "Текущий" : "Войти"}</span>
                </button>
            }
            {
                user.status == InvitationStatus.INVITED &&
                <button
                    className="new action-button primary"
                    onClick={async () => {
                        await accept(user)
                        const tokenData = prepareTokenData(user);
                        await finishAuth(props, $router, tokenData, 'profile')
                        props.$commitToStore({
                            role: user
                        })
                        await getUserList()
                    }}
                >
                    <span className="button-text">Принять приглашение</span>
                </button>
            }
        </div>
    }

    return <div>
        {
            makeUsersView()
        }
        {
            // Показываем кнопку "Добавить сотрудника" только если пользователь НЕ вошел через роль сотрудника
            !props.$store.userSession?.role_id &&
            (checkPermission(props, UserPermission.ADD_USERS) || checkPermission(props, UserPermission.OWNER)) &&
            <div className="profile-section-card profile-section-card--no-border ui-kit-v2" style={{marginTop: "20px"}}>
                <div className="profile-section-row">
                    <button
                        className="new action-button primary"
                        onClick={async () => {
                            setShowInvite(true)
                        }}
                    >
                        <span className="button-text">Добавить сотрудника в ваш аккаунт</span>
                    </button>
                </div>
            </div>
        }
        {
            props.$store.loading &&
            <PageLoader />
        }

        {
            showInvite &&
            <InviteEmployeePopup
                $store={props.$store}
                $commitToStore={props.$commitToStore}
                accessProfiles={accessProfiles}
                onClose={() => {setShowInvite(false)}}
                invite={async (phoneNumber: string, accessChoice: string) => {
                    setShowInvite(false)
                    await invite(phoneNumber, accessChoice)
                    await getUserList()
                }}
            />
        }

        {
            showDeleteAccount && accountToDelete &&
            <DeleteAccountPopup
                accountToDelete={accountToDelete}
                onClose={() => {
                    setShowDeleteAccount(false)
                    setAccountToDelete(null)
                }}
                onSuccess={async () => {
                    await getUserList()
                }}
            />
        }

        {
            profileEditor &&
            <AccessProfilePopup
                $store={props.$store}
                $commitToStore={props.$commitToStore}
                profile={profileEditor === "new" ? null : profileEditor}
                onClose={() => setProfileEditor(null)}
                onSaved={async () => {
                    setProfileEditor(null)
                    await loadAccessProfiles()
                    await getUserList()
                }}
            />
        }

        {
            templatesAccessRole &&
            <EmployeeTemplatesAccessPopup
                $store={props.$store}
                $commitToStore={props.$commitToStore}
                role={templatesAccessRole}
                onClose={() => setTemplatesAccessRole(null)}
                onSaved={async () => {
                    setTemplatesAccessRole(null)
                    await getUserList()
                }}
            />
        }

        {
            editRolePopupOpen && roleToEdit &&
            <Popup onClose={() => {
                setEditRolePopupOpen(false)
                setRoleToEdit(null)
                setRoleRepresentativeBasis("")
            }}>
                <div className="ui-kit-v2" style={{ minWidth: "320px" }}>
                    <div className="popup-title">Основание полномочий для сотрудника</div>
                    <div className="Body_16_v2_secondary" style={{ marginTop: "10px" }}>
                        Это значение будет использоваться в шапке договора при работе от имени вашего аккаунта этим сотрудником.
                        Пример: «в лице директора Иванова И.И., действующего на основании Устава».
                    </div>
                    <div style={{ marginTop: "12px" }}>
                        <textarea
                            className="ui-kit-v2"
                            style={{ width: "100%", minHeight: "110px", resize: "vertical" }}
                            placeholder="Введите текст…"
                            value={roleRepresentativeBasis}
                            onChange={(e) => setRoleRepresentativeBasis(e.target.value)}
                        />
                    </div>
                    <div style={{ marginTop: "12px", display: "flex", gap: "10px", justifyContent: "flex-end" }}>
                        <button
                            className="new action-button secondary"
                            onClick={() => {
                                setEditRolePopupOpen(false)
                                setRoleToEdit(null)
                                setRoleRepresentativeBasis("")
                            }}
                        >
                            <span className="button-text">Отмена</span>
                        </button>
                        <button
                            className="new action-button primary"
                            onClick={async () => {
                                await updateRoleRepresentativeBasis(roleToEdit, roleRepresentativeBasis)
                                setEditRolePopupOpen(false)
                                setRoleToEdit(null)
                                setRoleRepresentativeBasis("")
                                await getUserList()
                            }}
                        >
                            <span className="button-text">Сохранить</span>
                        </button>
                    </div>
                </div>
            </Popup>
        }
    </div>
}

TeamView = connect(
    (store) => ({ $store: store }),
    (dispatch) => ({
        $commitToStore: (data: any) => dispatch({ ...data, type: 'S' })
    })
)(TeamView)

export default TeamView